import axios from "axios";
import Vue from "vue";
axios.defaults.withCredentials = true;
import errorHandler from "@/scripts/errorHandler";
import { getApiBaseUrl } from "@/utils/RuntimeConfig";

let baseApi = getApiBaseUrl() + "/api/v2/";
Vue.prototype.baseUrl = baseApi;

export default class Axios {

  static getTokenFromUrl() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const tokenFromUrl = urlParams.get("token");

      if (tokenFromUrl) {
        // JWT格式验证
        const isValidFormat = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/.test(tokenFromUrl);

        if (!isValidFormat) {
          console.error("❌ URL参数token格式非法");
          return null;
        }

        sessionStorage.setItem("token", tokenFromUrl);

        // ponytail: 只摘掉 token，其余 query（如报告免登入口的 reportId）保留，否则刷新后参数就没了
        const url = new URL(window.location.href);
        url.searchParams.delete("token");
        window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);

        console.log("✅ Token已从URL参数自动注入sessionStorage");
        return tokenFromUrl;
      }
    } catch (error) {
      console.error("获取URL参数token失败:", error);
    }
    return null;
  }

  static getToken() {
    const tokenFromUrl = Axios.getTokenFromUrl();
    if (tokenFromUrl) {
      return tokenFromUrl;
    }
    // ponytail: 免登入口的 token 落在 sessionStorage（本标签页会话级），需优先于 localStorage 的登录态
    const tokenFromSession = sessionStorage.getItem("token");
    if (tokenFromSession) {
      return tokenFromSession;
    }
    const tokenFromStorage = localStorage.getItem("token");
    if (tokenFromStorage) {
      return tokenFromStorage;
    }
    console.warn("⚠️ 未找到可用的token，请重新登录");
    return null;
  }

  static clearToken() {
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    delete axios.defaults.headers.common["authorization"];
  }

  static ajax(options) {
    return new Promise((resolve, reject) => {
      const needsAuth = !options.noAuth;

      let token = null;
      if (needsAuth){
        token = Axios.getToken();

        axios.defaults.headers.common["authorization"] = token;
      }

      axios({
        url: options.url,
        method: options.method || 'POST',
        baseURL: baseApi,
        timeout: 80000,
        data: options.data || null,
        params: options.params || null,
        headers: options.headers || {}
      })
        .then((response) => {
          if (errorHandler.handleRequestRes(response)) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          // ✅ 修正后的语法（传统&&写法）
          if (error.code === 401) {
            Axios.clearToken();
            window.location.href = '/login?error=expired';
          }
          reject(error);
        });
    });
  }
}

// 模块加载时执行
Axios.getToken();
